/* eslint-env jquery */
const $ = jQuery;
const body = $('body');
const isLOPage = body.hasClass('single-employees');
let loRAW = '';

if (isLOPage) {
  $(document).ready(loInit);
}

function loInit() {
  if (document.cookie.includes('SESSnmls')) {
    loLocalStorage();
  } else {
    localStorage.removeItem('loan-officer');
  }
}

function loLocalStorage() {
  loRAW = $('input[name="employee_data"]').val().toString();
  // console.log(advisorJSON);
  window.localStorage.setItem('loan-officer', loRAW);
}
